const cdnUrl = location.host.indexOf('vip') === 0 ? `${location.protocol}//img.meiguanjia.net` : `${location.protocol}//testimg.meiguanjia.net`;
const imagePath = '/tenant/99950/';
const templateImagePath = '/malltemplatephoto/'

const imageUrlCDN = function(value, isTempImg, tenantId) {
    const customPath = tenantId ? imagePath.replace('99950', tenantId) : imagePath;
    const path = (isTempImg || isTempImg === undefined) ? templateImagePath : customPath;
    return `${cdnUrl}${path}${value}`;
}

export default {
    data() {
        return {
            tenantId: '',
        }
    },
    computed: {
        cdnPath() {
            return `${cdnUrl}${templateImagePath}`;
        }
    },
    filters: {
        urlCDN(value, isTempImg, tenantId) {
            return imageUrlCDN(value, isTempImg, tenantId);
        }
    },
    methods: {
        imageUrlCDN: imageUrlCDN
    }
}